import React from "react";
import { urlMiniatura } from "@/lib/miniaturas";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  fill?: boolean;
  /**
   * Pide la miniatura de 600 px en vez del original de 1920 px. Ponlo en todo
   * lo que se pinte dentro de una rejilla o un avatar; NUNCA en la vista a
   * pantalla completa. Si la miniatura no existe se cae al original solo. [165]
   */
  thumb?: boolean;
};

export default function Image({ src, alt = "", fill, thumb, style, onError, ...rest }: Props) {
  const original = typeof src === "string" ? src : (src as any);
  const mini = thumb ? urlMiniatura(original) : null;
  // `key` sobre el original: si cambia la foto hay que volver a intentar la
  // miniatura, no quedarse con el fallback de la anterior.
  const [falloMini, setFalloMini] = React.useState(false);
  React.useEffect(() => setFalloMini(false), [original]);

  const mergedStyle = fill
    ? { width: "100%", height: "100%", objectFit: "cover", ...style }
    : style;

  return (
    <img
      src={mini && !falloMini ? mini : original}
      alt={alt}
      style={mergedStyle}
      loading="lazy"
      onError={(e) => {
        if (mini && !falloMini) setFalloMini(true);
        onError?.(e);
      }}
      {...rest}
    />
  );
}
